<template>
  <div data-grm-comp="RoomCBTViewInfo" class="w-60 h-full">
    <div class="room-cbt-view-info">
      <div class="bg-indigo-50 flex justify-center items-center">
        <RoomCBTTimer class="w-full" />
      </div>
      <div class="room-cbt-view-info-body">
        <div class="room-cbt-view-info-contents">
          <div class="room-cbt-view-info-contents-header">
            <GrmCheckbox id="showAnswer" v-model="_showAnswer">{{ $t("testBank.info.showAnswer") }}</GrmCheckbox>
          </div>
          <perfect-scrollbar class="min-h-0 flex-1">
            <div class="room-cbt-view-info-contents-body">
              <RoomCBTInfoForm :users="getRoomProgressCBTUserList">{{ $t("testBank.info.ongoing") }}</RoomCBTInfoForm>
              <RoomCBTInfoForm :users="getRoomCompleteCBTUserList">{{ $t("testBank.info.submitComplete") }}</RoomCBTInfoForm>
            </div>
          </perfect-scrollbar>
        </div>
      </div>
      <div class="room-cbt-view-info-footer">
        <div class="room-cbt-view-button-wrapper">
          <button class="room-cbt-view-button finish" @click="onClickFinish">{{ $t("common.quit") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

import GrmCheckbox from "@/components/Common/input/GrmCheckbox.vue";
import RoomCBTTimer from "@/components/Room/CBT/RoomCBTTimer.vue";
import RoomCBTInfoForm from '@/components/Room/CBT/RoomCBTInfoForm.vue';
import {cloneDeep} from "lodash";

export default {
  name: 'RoomCBTViewInfo',
  components: {
    GrmCheckbox,
    RoomCBTTimer,
    RoomCBTInfoForm,
  },
  computed: {
    ...mapState('cbt', [
      'roomCBT',
      'showAnswer',
    ]),
    ...mapGetters('cbt', [
      'getRoomProgressCBTUserList',
      'getRoomCompleteCBTUserList',
    ]),

    _showAnswer: {
      get() {
        return this.showAnswer;
      },
      set() {
        this.TOGGLE_SHOW_ANSWER();
      }
    },
  },
  methods: {
    ...mapActions('cbt', [
      'endRoomCBT',
    ]),
    ...mapMutations('cbt', [
      'TOGGLE_SHOW_ANSWER',
    ]),

    onClickFinish() {
      this.$alert({
        title: this.$t('roomCbt.alert.quitCbt'),
        text: this.$t('roomCbt.alert.quitCbtText'),
        ok: () => {
          this.endRoomCBT({
            roomCbtId: this.roomCBT.roomCbtId
          });
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.room-cbt-view-info {
  height: 100%;
  box-shadow: -10px 0 40px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
}
.room-cbt-view-info-body {
  min-height: 0;
  flex: 1;
  background-color: rgba(240, 240, 248, 0.94);
}
.room-cbt-view-info-contents {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.room-cbt-view-info-contents-header {
  height: 46px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0 16px;
  background-color: #fff;
  display: flex;
  align-items: center;
}
.room-cbt-view-info-contents-body {}
.room-cbt-view-info-footer {}
.room-cbt-view-button-wrapper {}
.room-cbt-view-button {
  width: 100%;
  height: 60px;
  text-align: center;
  font-size: 21px;
  color: #fff;
  &.finish {
    background: #4f4e5b url('~@/assets/images/flag.svg') no-repeat center left 20px / 20px auto;
  }
  &:hover {
    background-color: #ff005a;
  }
}

// Component
.room-cbt-view-info-form-component {
  &::v-deep {
    &:first-child {
      .room-cbt-view-state-form {
        border-top: 0;
      }
    }
    .room-cbt-view-state-form {
      border-top: 1px solid rgba(0, 0, 0, 0.2);
    }
  }
}
</style>